// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root___xA5j","title":"Hero_title__Q0tn0","description":"Hero_description__qhVfY"};